<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex xs12">
        <va-card :title="page_name">
          <!-- $t('tables.orders.token') + ' ' + this.$route.params.token -->
          <form @submit.prevent>
            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-select
                  :label="user_label"
                  v-model="assemblerParams.user.user_name"
                  keyBy="id"
                  textBy="name"
                  :options="mounters"
                  searchable
                />
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input
                  :label="$t('tables.orders.token')"
                  v-model="assemblerParams.token"
                  value="order.token"
                />
              </div>

              <div class="flex md4 sm6 xs12">
                <va-select
                  :label="$t('tables.orders.priority_name')"
                  v-model="assemblerParams.priority"
                  keyBy="id"
                  textBy="name"
                  :options="listOrderPriorities"
                />
              </div>

                <!-- <div class="flex md4 sm6 xs12">
                  <va-select
                    :label="$t('forms.selects.step')"
                    v-model="assemblerParams.order_step"
                    keyBy="step_sequence"
                    textBy="name"
                    :options="order_steps"
                  />
                </div> -->

              <div class="flex md4 sm6 xs12">
                <va-input
                  :label="$t('tables.orders.note')"
                  v-model="assemblerParams.note"
                  value="order.note"
                  type="textarea"
                  :maxlength="50"
                />
              </div>



            </div>

            <div class="row">
              <div class="flex md3 sm6 xs12">
                <va-button
                  medium
                  inline
                  color="secondary"
                  icon="fa fa-save"
                  class="mr-1"
                  @click="update(assemblerParams)"
                >
                  {{ $t('menu.update') }}
                </va-button>

                <va-button
                  v-if="this.$route.params.page_name == 'mounting'"
                  medium
                  inline
                  color="#ff842b"
                  icon="fa fa-chevron-left"
                  class="ma-0"
                  :to="{ name: 'mounting', params: {
                    current_page: this.$route.params.current_page,
                    searchName: this.$route.params.searchName,
                    delivery_date: this.$route.params.delivery_date,
                    perPage: this.$route.params.perPage }
                    }"
                >
                  {{ $t('menu.back') }}
                </va-button>
                <va-button
                  v-if="this.$route.params.page_name == 'conferencing'"
                  medium
                  inline
                  color="#ff842b"
                  icon="fa fa-chevron-left"
                  class="ma-0"
                  :to="{ name: 'conferencing', params: {
                    current_page: this.$route.params.current_page,
                    searchName: this.$route.params.searchName,
                    delivery_date: this.$route.params.delivery_date,
                    perPage: this.$route.params.perPage }
                    }"
                >
                  {{ $t('menu.back') }}
                </va-button>
                <va-button
                  v-if="this.$route.params.page_name == 'stacking'"
                  medium
                  inline
                  color="#ff842b"
                  icon="fa fa-chevron-left"
                  class="ma-0"
                  :to="{ name: 'stacking', params: {
                    current_page: this.$route.params.current_page,
                    searchName: this.$route.params.searchName,
                    delivery_date: this.$route.params.delivery_date,
                    perPage: this.$route.params.perPage }
                    }"
                >
                  {{ $t('menu.back') }}
                </va-button>
                <va-button
                  v-if="this.$route.params.page_name == 'layer_picking'"
                  medium
                  inline
                  color="#ff842b"
                  icon="fa fa-chevron-left"
                  class="ma-0"
                  :to="{ name: 'layer_picking', params: {
                    current_page: this.$route.params.current_page,
                    searchName: this.$route.params.searchName,
                    delivery_date: this.$route.params.delivery_date,
                    perPage: this.$route.params.perPage }
                    }"
                >
                  {{ $t('menu.back') }}
                </va-button>
                <va-button
                  v-if="this.$route.params.page_name == 'conference_supervision'"
                  medium
                  inline
                  color="#ff842b"
                  icon="fa fa-chevron-left"
                  class="ma-0"
                  :to="{ name: 'conference_supervision', params: {
                    current_page: this.$route.params.current_page,
                    searchName: this.$route.params.searchName,
                    delivery_date: this.$route.params.delivery_date,
                    perPage: this.$route.params.perPage }
                    }"
                >
                  {{ $t('menu.back') }}
                </va-button>
                <va-button
                  v-if="this.$route.params.page_name == 'vehicle_liberation'"
                  medium
                  inline
                  color="#ff842b"
                  icon="fa fa-chevron-left"
                  class="ma-0"
                  :to="{ name: 'vehicle_liberation', params: {
                    current_page: this.$route.params.current_page,
                    searchName: this.$route.params.searchName,
                    delivery_date: this.$route.params.delivery_date,
                    perPage: this.$route.params.perPage }
                    }"
                >
                  {{ $t('menu.back') }}
                </va-button>
                <va-button
                  v-if="this.$route.params.page_name == 'transporting'"
                  medium
                  inline
                  color="#ff842b"
                  icon="fa fa-chevron-left"
                  class="ma-0"
                  :to="{ name: 'transporting', params: {
                    current_page: this.$route.params.current_page,
                    searchName: this.$route.params.searchName,
                    delivery_date: this.$route.params.delivery_date,
                    perPage: this.$route.params.perPage }
                    }"
                >
                  {{ $t('menu.back') }}
                </va-button>
              </div>
            </div>
          </form>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>
import MountingFlowAPI from '@/services/MountingFlowAPI'
import OrderAPI from '@/services/OrdersAPI'
import UserAPI from '@/services/UserAPI'
import OrderPriorityAPI from '@/services/OrderPriorityAPI'
import BackButton from '../../shared/BackButton'
import { showError } from '@/global'
import { mapState } from "vuex";

export default {
  components: { BackButton },
  data () {
    return {
      assemblerParams: {
        assemblerId: '',
        priority: '',
        pallet_type_id: '',
        order_step: {
          step_sequence: '',
          name: '',
        },
        user: {
          user_id: '',
          user_name: '',
          user_old: '',
        },
        token: '',
        note: '',
      },
      mounters: [],
      listOrderPriorities: [],
      order_steps: [],
    }
  },

  computed: {
    ...mapState(['currentLocality']),

    page_name: function () {
      return this.$t(`menu.${this.$route.params.page_name}`) + ' ' + this.$t('tables.orders.token') + ' ' + this.$route.params.token
    },

    user_label: function () {
      if (this.$route.params.page_name == 'conferencing') {
        return this.$t('tables.load_sequence.conferent')
      } else {
        if (this.$route.params.pallet_type == "RETORNAVEL") {
          return this.$t('tables.orders.separator')
        } else {
          return this.$t('tables.orders.mounter')
        }
      }
    },
  },

  mounted(){
    OrderAPI.getOrder(this.$route.params.order_id).then(response => {

      this.assemblerParams.assemblerId = response.data.order.id
      this.assemblerParams.token = response.data.order.token
      this.assemblerParams.pallet_type_id = response.data.order.pallet_type_id
      this.assemblerParams.priority = response.data.order.priority
      this.assemblerParams.order_step.name = response.data.order.order_step_name
      this.assemblerParams.note = response.data.order.note
      this.assemblerParams.user_old = response.data.order.user_full.id
      if (response.data.order.user_full != undefined) {
        this.assemblerParams.user.user_name = response.data.order.user
        this.assemblerParams.user.user_id = response.data.order.user_id
      }
    })

    if (this.$route.params.pallet_type == "RETORNAVEL") {
      this.label_people = this.$t('tables.orders.separator')
    } else {
      this.label_people = this.$t('tables.orders.mounter')
    }

    let by_role = 0;

    switch(this.$route.params.page_name) {
      case "conferencing":
        by_role = 2
        break;
      case "stacking":
        by_role = 3
        break;
      case "layer_picking":
        by_role = 4
        break;
      case "conference_supervision":
        by_role = 9
        break;
      case "vehicle_liberation":
        by_role = 2
        break;
      case "transporting":
        by_role = 11
        break;
      case "mounting":
        if ( this.$route.params.pallet_type == "RETORNAVEL"){
          by_role = 14
        } else {
          by_role = 1
        }
        break;
    }

    MountingFlowAPI.getOrderStepsByPalletType(this.$route.params.pallet_type_id, this.currentLocality.id).then(response => {
      this.order_steps = response.data.order_steps
    })

    UserAPI.getUsersByRoleAndLocality(by_role, this.currentLocality.id).then(response => {
      this.mounters = response.data.users
    })

    OrderPriorityAPI.getAllOrderPriorities().then(response => {
      this.listOrderPriorities = response.data.order_priorities
    })

  },
  methods: {
    update (assemblerParams) {

      OrderAPI.updateAssembler(assemblerParams).then(response => {
        self.data = response.data;

        this.showToast(response.data.message, {
            icon: 'fa-thumbs-o-up',
            position: 'top-right',
            duration: 5000,
        }),

        this.$router.push('/admin/tables/' + this.$route.params.page_name)
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    }
  }
}
</script>
